import { Card, CardContent } from "@mui/material";
import type { StatisticsReport } from "../../lib/types";
import { formatCurrency } from "./formatters";
import { EmptyStatisticsCard } from "./StatisticsRankings";

export function StatisticsAccounts({ report, onAccount }: { report: StatisticsReport; onAccount: (accountId: string) => void }) {
  return (
    <Card className="records-panel stat-card stat-wide-card"><CardContent className="records-panel-content">
      <div className="stat-card-heading"><h2>Account flow</h2><span>Income, expenses, and transfers</span></div>
      <div className="stat-account-table">
        {report.accounts.map((account) => <button type="button" key={account.account_id} onClick={() => onAccount(account.account_id)} title="Show in Records"><strong>{account.account_name}</strong><span>{formatCurrency(account.income, account.currency)} in</span><span>{formatCurrency(account.expense, account.currency)} out</span><span>{formatCurrency(account.transfer_in, account.currency)} transfers in</span><span>{formatCurrency(account.transfer_out, account.currency)} transfers out</span><b>{formatCurrency(account.net_flow, account.currency)}</b></button>)}
        {!report.accounts.length ? <EmptyStatisticsCard message="No account movement in this period." /> : null}
      </div>
    </CardContent></Card>
  );
}
